import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import { TextField } from '@mui/material';
import Stack from '@mui/material/Stack';
import { useSnackbar } from '../../../context/SnackbarContext';
import { useTranslation } from 'react-i18next';
import { updateOffice } from '../../../api/officeService';

export default function ClinicInfoForm({ successCallback = null, office = null, mode = "edit", open, onClose }) {

    const { t } = useTranslation('common'); 

    const [email, setEmail] = React.useState(office ? office.email  : "");
    const [contactNumber, setContactNumber] = React.useState(office ? office.contact_number : "");
    const [address, setAddress] = React.useState(office ? office.address : "");

    const { showSnackbar } = useSnackbar();

    const onUpdateSuccess = () => {
      successCallback();
    };

    React.useEffect(() => {
      // reset field when there are changes (e.g. when opening edit)
      setEmail(office ? office.email : "");
      setContactNumber(office ? office.contact_number : "");
      setAddress(office ? office.address : "");
    }, [office, open]);

    const handleSave = async () => {
        try 
        {
          if (mode === "edit" && office) {
              await updateOffice(office.id, { 
                  email: email,
                  contact_number: contactNumber,
                  address: address 
              });
              onUpdateSuccess();
              showSnackbar(t('settings.messages.clinic_info_update_success'), "success");
          }
          setEmail("");
          setContactNumber("");
          setAddress("");
          onClose();     // close dialog
        } catch (err) {
          showSnackbar(t('settings.messages.clinic_info_save_fail'), "error");
        }

    };

    const handleCancel = () => {
      setEmail("");
      setContactNumber("");
      setAddress("");
      onClose();
    };

    return (
        <>
        <Dialog onClose={handleCancel} open={open} disableRestoreFocus>

        <DialogTitle>Edit Contact Information</DialogTitle>

        <DialogContent dividers>
            <Stack spacing={1}>
            <TextField
                label="E-mail"
                variant="outlined"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                fullWidth
            />
            <TextField
                label="Contact Number"
                variant="outlined"
                value={contactNumber}
                onChange={(e) => setContactNumber(e.target.value)}
                fullWidth
            />
            <TextField
                label="Address"
                variant="outlined"
                value={address}
                onChange={(e) => setAddress(e.target.value)}
                fullWidth
                multiline
                rows={2}
            />
            </Stack>
        </DialogContent>

        <DialogActions>
            <Button onClick={handleSave}>
              Save
            </Button>
            <Button onClick={handleCancel}>Cancel</Button>
        </DialogActions>
        </Dialog>
        </>
    );
}